import { MagnifyingGlass } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";
import { useRunCommand } from "@/lib/commands/CommandProvider";

export function TopSearchBar() {
  const runCommand = useRunCommand();
  const cmdShortcut =
    typeof navigator !== "undefined" && /Mac/i.test(navigator.platform)
      ? "⌘K"
      : "Ctrl K";

  return (
    <div className="px-3 pb-2 pt-1.5">
      <Button
        type="button"
        variant="outline"
        onClick={() => runCommand("app.openCommandPalette")}
        className="h-[26px] w-full min-w-0 justify-start gap-2 rounded-full border-border bg-foreground/[0.04] pl-3 pr-[3px] text-xs font-normal text-muted-foreground shadow-sm hover:bg-foreground/10 hover:text-foreground"
        title="Open command palette"
      >
        <MagnifyingGlass size={13} weight="Linear" className="shrink-0" />
        <span className="min-w-0 flex-1 truncate text-left">Search</span>
        <kbd className="ml-auto hidden h-[18px] shrink-0 items-center rounded-full bg-foreground/[0.08] px-2 font-mono text-[10px] leading-none text-muted-foreground/80 lg:inline-flex">
          {cmdShortcut}
        </kbd>
      </Button>
    </div>
  );
}
